module.exports = __webpack_public_path__ + "static/assets/ee42f0a1b1e51f3804fc5616d9c1b102.png";